import _ from 'lodash'
import createModel from 'utils/model'
import {formatTableParams} from 'utils/index'
import {getWarningList} from './service'

export default createModel({
    namespace: 'orderList',
    state: {
        tableList: {},
    },

    effects: {
        *getTableList(x, {select, put, call}) {
            const {tableList} = yield select(({orderList}) => orderList)
            const params = formatTableParams(tableList)
            const res = yield call(getWarningList, params)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableList.dataSource = res.data
                    draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },
    },
})
